class StToast {
    static $inject = ['toastr', 'toastrConfig'];

    constructor(toastr, toastrConfig) {
        this.toastr = toastr;
        this.toastrConfig = toastrConfig;
    }

    /**
     * @param {string} title 
     * @param {string} message 
     */
    success = (title, message) => {
        this.toastr.success(message, title, {
            allowHtml: true
        });
    }

    /**
     * @param {string} title 
     * @param {string} message 
     */
    info = (title, message) => {
        if (message == null) message = '';
        const closeMessage = this.toastrConfig.closeMessage == null ? ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>(Click this message to close it.)</i>' : this.toastrConfig.closeMessage;
        this.toastr.info(`${message}${closeMessage}`, title, {
            allowHtml: true,
            closeButton: true,
            autoDismiss: false,
            tapToDismiss: true,
            hoverToClose: false,
            timeOut: 0,
            extendedTimeOut: 0
        });
    }

    /**
     * @param {string} title 
     * @param {string} message
     */
    error = (title, message) => {
        if (message == null) message = '';
        const closeMessage = this.toastrConfig.closeMessage == null ? ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>(Click this message to close it.)</i>' : this.toastrConfig.closeMessage;
        this.toastr.error(`${message}${closeMessage}`, title, {
            allowHtml: true,
            closeButton: true,
            autoDismiss: false,
            tapToDismiss: true,
            hoverToClose: false,
            timeOut: 0,
            extendedTimeOut: 0
        });
    }

    /**
     * @param {Error} err 
     * @param {string} [title]
     */
    errorHandler = (err, title) => {
        if (!err || !err.status) {
            console.log('stToast.errorHandler called with invalid parameters', err, title);
            return;
        }

        if (err.status === 400) {
            const tit = title || 'Information';
            let msg = err.statusText; // data.Message
            if (msg === 'Bad Request' && err.data && err.data.Message)
                msg = err.data.Message;
            console.log(`${tit} ${msg}`, err);
            this.info(tit, msg);
        } else {
            const tit = title || 'Error';
            const msg = 'Something went wrong and it was logged. If you need further support please contact development@streamlinedb.com.';
            console.log(`${tit} ${msg}`, err);
            this.error(tit, msg);
        }
    }
}

angular
    .module('stToast', ['toastr'])
    .service('stToast', StToast);
